module.exports = __webpack_public_path__ + "static/lenvima-chart-mobile-de336db339c0c74e2c94b88c01d8a804.png";